import { FALLBACK_COLUMN_BG_COLOR } from '@crm/pages/deals/config';

import type { TDealColumnColor } from '@crm/entities/deals-board';

export const COLOR_PICKER_BG_CSS_VAR = '--color-picker-bg';
export const COLOR_PICKER_BG_CLASS_NAME = 'bg-[var(--color-picker-bg)]';
export const COLOR_PICKER_FOCUS_BG_CLASS_NAME = 'focus:bg-[var(--color-picker-bg)]';
export const COLOR_PICKER_HIGHLIGHTED_BG_CLASS_NAME =
    'data-[highlighted]:bg-[var(--color-picker-bg)]';
export const COLOR_PICKER_HOVER_BG_CLASS_NAME = 'hover:bg-[var(--color-picker-bg)]';

export const getColorPreviewBgColor = (
    value: string,
    columnColors: TDealColumnColor[]
) => columnColors.find(({ color }) => color === value)?.bgColor ?? FALLBACK_COLUMN_BG_COLOR;
